import { CASES_PATH, UPDATES_PATH } from "../../constants";
import createLink from "../createLink";

export default function formatCase({
  type,
  id,
  customer,
  thumbnail,
  title,
  overviewTitle,
  slug,
  domain,
  products,
  highlighted,
}) {
  switch (type) {
    case "DatoCMS_CaseRecord":
      return {
        id: id,
        client: customer.name,
        title: overviewTitle || title,
        image: {
          data: highlighted ? thumbnail.highlight : thumbnail.small,
        },
        domain,
        highlighted: highlighted,
        product: products[0]?.title,
        as: createLink(`${CASES_PATH}/${slug}`),
      };
    case "DatoCMS_UpdateRecord":
      return {
        id: id,
        title: title,
        image: {
          data: thumbnail.small,
        },
        as: createLink(`${UPDATES_PATH}/${slug}`),
      };
  }
}
